import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { createAllInOutbound } from '../../../../api/outbound/pokerOutbounds';
import { ScaledTextButton } from '../../../../components/scaledTextButton';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { getChipsDisplayStr } from '../../../../utils/chipsDisplayUtils';
export const DomAllInButton = ({ bounds, myTurnProperties, showChipsAsBbMultiple, bigBlind }) => {
    const socketSend = useSocketSend();
    const onClickAllIn = useCallback(() => {
        socketSend(createAllInOutbound(myTurnProperties.betSequenceNumber));
    }, [myTurnProperties, socketSend]);
    const numChips = myTurnProperties.myNumChipsThisPhase + myTurnProperties.myNumChips;
    const subLabel = useMemo(() => {
        if (numChips > 0) {
            return getChipsDisplayStr({
                numChips,
                showChipsAsBbMultiple,
                bigBlind,
                truncateZeroDecimals: false
            });
        }
    }, [showChipsAsBbMultiple, bigBlind, numChips]);
    const { x, y, w, h } = bounds;
    return (_jsx(ScaledTextButton, { onClick: onClickAllIn, label: 'ALL-IN', subLabel: subLabel, testId: 'all-in', x: x, y: y, w: w, h: h, accentColor: 'green' }));
};
